export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-09.70535b63.jpg";